import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { InfoBoxType } from '@/models/InfoBox';
import BCXSidebarOrLayer from '@/components/molecules/BCXSidebarOrLayer.vue';
import useInvoiceActionState from '@/views/my-projects/components/invoices/action-box/useInvoiceActionState';
import InvoicesActionButtons from '@/views/my-projects/components/invoices/action-box/InvoicesActionButtons.vue';
import InvoicesNewInvoiceAction from '@/views/my-projects/components/invoices/action-box/InvoicesNewInvoiceAction.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import { useRoute, useRouter } from 'vue2-helpers/vue-router';
import useResponsiveness from '@/mixins/useResponsiveness';
import useUser from '@/mixins/useUser';


export default /*#__PURE__*/_defineComponent({
  __name: 'InvoicesActions',
  props: {
  inBox: Boolean
},
  setup(__props) {

const { mode } = useInvoiceActionState();
const { isMobileWidth, isTabletWidth } = useResponsiveness();
const router = useRouter();
const route = useRoute();
const { tUserFallback: t } = useUser('self');

const infoBoxType = computed(() => (mode.value === 'new-invoice' ? InfoBoxType.INFOBOX_APPLY : InfoBoxType.INFOBOX_STANDARD));
const hasBackButton = computed(() => mode.value === 'new-invoice');



const onNewInvoice = () => {
  mode.value = 'new-invoice';
};

const navigateToInvoices = () => {
  router.push('/my-projects/invoices');
};

const title = computed(() => (mode.value === 'new-invoice' ? `${t('invoices.actions.create-invoice.title_USERTYPE')}` : `${t('invoices.actions.sidebar-title_USERTYPE')}`));

return { __sfc: true,mode, isMobileWidth, isTabletWidth, router, route, t, infoBoxType, hasBackButton, onNewInvoice, navigateToInvoices, title, BCXSidebarOrLayer, InvoicesActionButtons, InvoicesNewInvoiceAction, BCXButton }
}

})